import styled, { keyframes, css } from 'styled-components';
import { transparentize as fade } from 'polished';
import Button from '../Button';
import pxToRem from '../../utils/convertPxToRem';
var Animation = /*#__PURE__*/keyframes(["0%{opacity:0;transform:scale(1);}100%{opacity:1;transform:scale(7);}"]);
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-12xh9ks-0"
})(["position:relative;text-align:right;"]);
export var MicroWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__MicroWrapper",
  componentId: "sc-12xh9ks-1"
})(["display:flex;align-items:center;flex-direction:row-reverse;max-width:", ";position:relative;transition:all 0.5s;height:", ";margin-left:auto;margin-right:0;"], function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? '100%' : pxToRem(50);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.sizes.sz32;
});
export var visibilityStyles = /*#__PURE__*/css(["opacity:", ";visibility:", ";transition:all 0.5s;"], function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen ? '1' : '0';
}, function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen ? 'visible' : 'hidden';
});
export var PlusButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "styles__PlusButton",
  componentId: "sc-12xh9ks-2"
})(["position:absolute;right:0;"]);
export var MinusButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "styles__MinusButton",
  componentId: "sc-12xh9ks-3"
})(["position:absolute;left:0;", ";"], visibilityStyles);
export var QuantityButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "styles__QuantityButton",
  componentId: "sc-12xh9ks-4"
})(["position:absolute;font-weight:", ";font-size:", ";color:", ";border-radius:", ";width:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fonts.fontWeight.normal;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fonts.fontSize.ft16;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.text.primary;
}, pxToRem(50), function (_ref8) {
  var initialValue = _ref8.initialValue,
    multiplier = _ref8.multiplier;
  return initialValue && initialValue !== multiplier && pxToRem(50);
});
export var ElementWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ElementWrapper",
  componentId: "sc-12xh9ks-5"
})(["border:", " solid ", ";display:inline-block;position:relative;text-align:center;min-width:", ";max-width:", ";height:", ";border-radius:", ";&:focus-within,&:hover{border:", " solid ", ";border-color:", ";}"], pxToRem(1), function (_ref9) {
  var hasError = _ref9.hasError,
    theme = _ref9.theme;
  return !hasError ? "".concat(theme.colors.border.midGray) : "".concat(theme.colors.border.alert);
}, function (_ref10) {
  var small = _ref10.small;
  return small ? pxToRem(100) : pxToRem(120);
}, function (_ref11) {
  var small = _ref11.small;
  return small ? pxToRem(120) : pxToRem(144);
}, function (_ref12) {
  var small = _ref12.small;
  return small ? pxToRem(38) : pxToRem(46);
}, function (_ref13) {
  var rounded = _ref13.rounded;
  return rounded ? pxToRem(1000) : 0;
}, pxToRem(1), function (_ref14) {
  var hasError = _ref14.hasError,
    theme = _ref14.theme;
  return !hasError ? "".concat(theme.colors.border.primary) : "".concat(theme.colors.border.alert);
}, function (_ref15) {
  var disabled = _ref15.disabled,
    theme = _ref15.theme;
  return disabled ? "".concat(theme.colors.border.midGray) : null;
});
export var ErrorMessage = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__ErrorMessage",
  componentId: "sc-12xh9ks-6"
})(["color:", ";display:block;font-family:", ";font-size:", ";padding:", " 0;text-align:left;"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.border.alert;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fonts.fontSize.ft14;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.spacing.sp4;
});
export var StyledButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-12xh9ks-7"
})(["align-items:center;appearance:none;background:transparent;border:none;border-radius:", ";color:", ";display:flex;font-size:", ";height:100%;justify-content:center;outline:none;position:absolute;right:0;top:0;transition:color 100ms cubic-bezier(0.46,0.03,0.52,0.96);user-select:none;width:", ";overflow:hidden;cursor:pointer;&:hover{background:transparent;}&:focus-visible{background:", ";}svg{z-index:", ";}&:active{color:", ";background:transparent;&:before{content:'';display:block;background:", ";position:absolute;height:", ";width:", ";border-radius:50%;animation:", " 0.3s ease-in-out;}}&:disabled{color:", ";cursor:default;&:before{display:none;}svg{fill:", ";}}&:first-child{right:auto;left:0;border-radius:", ";}"], function (_ref20) {
  var rounded = _ref20.rounded;
  return rounded ? "0 ".concat(pxToRem(1000), " ").concat(pxToRem(1000), " 0") : 0;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.text.secondary;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.fonts.fontSize.ft18;
}, function (_ref23) {
  var small = _ref23.small;
  return small ? pxToRem(40) : pxToRem(46);
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors["default"].blueA50;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.stacking.infront;
}, function (_ref26) {
  var theme = _ref26.theme;
  return fade(0.5, theme.colors.text.secondary);
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.background.tertiary;
}, pxToRem(10), pxToRem(10), Animation, function (_ref28) {
  var theme = _ref28.theme;
  return theme.colors.text.midGray;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.text.midGray;
}, function (_ref30) {
  var rounded = _ref30.rounded;
  return rounded ? "".concat(pxToRem(1000), " 0 0 ").concat(pxToRem(1000)) : 0;
});

/**
 * The triple &&& which make the styling for this element more specific.
 */

export var Input = /*#__PURE__*/styled.input.attrs({
  type: 'number'
}).withConfig({
  displayName: "styles__Input",
  componentId: "sc-12xh9ks-8"
})(["&&&{appearance:textfield;width:", ";position:", ";left:", ";background:transparent;border:", ";border-color:", ";box-shadow:none;box-sizing:border-box;font-family:", ";font-size:", ";height:", ";line-height:", ";border-radius:", ";margin:0;max-width:100%;outline:none;padding:0 ", ";", ";text-align:center;", ";&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{appearance:none;}&::-ms-clear{display:none;}}&:focus-visible{font-weight:", ";color:", ";}&:disabled{color:", ";}"], function (_ref31) {
  var micro = _ref31.micro;
  return micro ? pxToRem(50) : '100%';
}, function (_ref32) {
  var micro = _ref32.micro;
  return micro ? "absolute" : 'relative';
}, function (_ref33) {
  var micro = _ref33.micro;
  return micro ? "calc(50% - ".concat(pxToRem(25), ")") : null;
}, function (_ref34) {
  var micro = _ref34.micro,
    theme = _ref34.theme;
  return micro ? "".concat(pxToRem(1), " solid ").concat(theme.colors.border.primary) : 'none';
}, function (_ref35) {
  var hasError = _ref35.hasError,
    theme = _ref35.theme;
  return hasError ? theme.colors.border.alert : theme.colors.border.primary;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref37) {
  var small = _ref37.small,
    theme = _ref37.theme;
  return small ? theme.fonts.fontSize.ft14 : theme.fonts.fontSize.ft16;
}, function (_ref38) {
  var micro = _ref38.micro,
    theme = _ref38.theme;
  return micro ? theme.sizes.sz32 : '100%';
}, function (_ref39) {
  var micro = _ref39.micro;
  return micro ? pxToRem(30) : pxToRem(42);
}, function (_ref40) {
  var micro = _ref40.micro;
  return micro ? pxToRem(500) : '0';
}, function (_ref41) {
  var micro = _ref41.micro;
  return !micro && pxToRem(44);
}, function (_ref42) {
  var small = _ref42.small;
  return small && "padding: 0 ".concat(pxToRem(40), ";");
}, function (_ref43) {
  var micro = _ref43.micro;
  return micro && visibilityStyles;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.fonts.fontWeight.medium;
}, function (_ref45) {
  var theme = _ref45.theme,
    hasError = _ref45.hasError;
  return hasError ? theme.colors.signal.alert : theme.colors.text.secondary;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.colors.text.midGray;
});
Wrapper.displayName = 'Wrapper';
Input.displayName = 'Input';
StyledButton.displayName = 'StyledButton';
ErrorMessage.displayName = 'ErrorMessage';